import { Static, Object, String, Optional } from '@sinclair/typebox';

import { ProductCode } from './travel-pass';

export const TravelPassRebookRequest = Object({
  pnr: String(),
  lastName: String(),
  offerId: String(),
  productCode: ProductCode,
  selectedOutboundCabinId: Optional(String()),
  selectedInboundCabinId: Optional(String()),
});
export type TravelPassRebookRequest = Static<typeof TravelPassRebookRequest>;

export const TravelPassRebookResponse = Object({
  pnr: String(),
});
export type TravelPassRebookResponse = Static<typeof TravelPassRebookResponse>;
